import { Component } from '@angular/core';

import { TourismEventsComponent } from '../tourism-events.common';
import { CategoryEvent } from '../tourism-events.model';

@Component({
	selector: 'app-tourism-events-duty',
	templateUrl: './tourism-events-duty.component.html',
	styleUrls: ['./tourism-events-duty.component.css'],
})
export class TourismEventsDutyComponent extends TourismEventsComponent {
	errors = {
		name: '',
		vehicles: [],
		date_from: '',
		date_to: '',
	};

	protected defaultValues() {
		this.event.status = 'PRELIMINARY';
		this.event.category = CategoryEvent.ENSILAGE;
		this._serviceEvent.organization.subscribe((result) => {
			this.event.client = result;
			this.event.clientEvent = {
				client: result.id,
				event: null,
				isOrganization: '1',
			};
		});
		this.event.drivers_departure.push();
	}
}
